<template>
  <div class="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 transform">
    <div
      v-tooltip="{ value: t('contact.actions.impersonateStop'), showDelay: 300 }"
      class="has-background-primary flex h-15 w-15 cursor-pointer items-center justify-center rounded-full text-primary-contrast shadow-lg hover:text-orange-500"
      @click="stopImpersonation"
    >
      <AppIcon
        class="transform transition-transform duration-200 hover:animate-pulse"
        name="solid-person-to-portal"
        size="lg"
      />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import useImpersonation from '@/app/util/impersonation';

const { t } = useI18n();
const { stopImpersonation } = useImpersonation();

defineProps({
  profile: { type: Object, required: true },
});
</script>
